import type { SkuUnit } from '@gutterinv/shared';
import {
  isGutterCoilCategory,
  isBattingCategory,
  isDownspoutCategory,
  isSealerPaintCategory,
} from './product-line.js';

/** Recommended Buy/Sell/Count-in for a category (New SKU pre-fill). */
export interface UomDefault {
  /** purchaseUom (canonical). */
  buy: string;
  /** consumptionUom (canonical). */
  sell: string;
  /** base `unit` — what on-hand is COUNTED in (countable enum only). */
  base: SkuUnit;
}

export const UOM_DEFAULT_FALLBACK: UomDefault = { buy: 'EA', sell: 'EA', base: 'ea' };

// Category → recommended Buy/Sell/Count-in. Only the NON-EA categories need an
// explicit rule; every EA/EA/ea category (Elbows, Miters, Wedges, Accessories, Misc,
// Tools, Hangers, Guards, Fasteners, Outlets, End Caps, Bolts & Anchors, Adapters…)
// correctly resolves to the fallback, so a NAME miss on those is harmless. The five
// special categories are matched via the app's existing canonical name classifiers
// (product-line.ts — the single source of truth for those names) + one exact-name
// check for Staples (which the fastener classifier groups with the EA categories).
// Guarded by uom-defaults.test.ts against the live category names.
export function uomDefaultsForCategory(name: string): UomDefault {
  if (isGutterCoilCategory(name)) return { buy: 'LB', sell: 'LF', base: 'ft' };
  if (isBattingCategory(name)) return { buy: 'BAG', sell: 'SF', base: 'bag' };
  if (isDownspoutCategory(name)) return { buy: 'FT', sell: 'FT', base: 'ea' };
  if (name.trim().toLowerCase() === 'staples') return { buy: 'BOX', sell: 'PC', base: 'box' };
  if (isSealerPaintCategory(name)) return { buy: 'CAN', sell: 'CAN', base: 'can' };
  return UOM_DEFAULT_FALLBACK;
}
